
import './AddSalariesForm.css'
import CustomInput from "../CustomInput/CustomInput";
import CustomBtn from "../CustomBtn/CustomBtn";
import { useEffect, useState } from 'react';
import { Col, Container, Row } from 'react-bootstrap';
import "react-toastify/dist/ReactToastify.css";
import Select from 'react-select';

// import axios from 'axios';
import { useSelector } from 'react-redux';
import { toast, ToastContainer } from 'react-toastify';
import { useNavigate } from 'react-router-dom';
import axios from 'axios';

function AddSalariesForm() {
  const userinfo = useSelector((state) => state);
  const { currentLocal } = useSelector((state) => state.currentLocal);
  const navigate = useNavigate();
  const [image, setImage] = useState(null);
  const [preview, setPreview] = useState(null);
  const [type_id, setType_id] = useState("");
  const [grade_id, setGrade_id] = useState("");
  const [employee_id, setEmployee_id] = useState("");
  const [bonous, setBonous] = useState(0);
  const [bonus_reason, setBonus_reason] = useState("");
  const [deduction, setDeduction] = useState(0);
  const [deduction_reason, setDeduction_reason] = useState("");

  const [price, setPrice] = useState('')
  // eslint-disable-next-line react-hooks/rules-of-hooks
  const [description, setDescription] = useState('')
  // eslint-disable-next-line react-hooks/rules-of-hooks
  const [password, setPssword] = useState('')
  // eslint-disable-next-line react-hooks/rules-of-hooks
  const [phone, setPhone] = useState('')

  // eslint-disable-next-line react-hooks/rules-of-hooks
  const [loading, setLoading] = useState('')
  const handleImageChange = (e) => {
    const file = e.target.files[0];
    if (file) {
      setImage(file);
      setPreview(URL.createObjectURL(file));
    }
  };

  const handleRemoveImage = () => {
    setImage(null);
    setPreview(null);
  };

  const [items, setItems] = useState([])
  useEffect(() => {
    const getAllApis = async () => {


      await axios
        .get(`https://nanosoft.space/taarteb/public/api/admin/employees`, {
          headers: {
            Authorization: `Bearer ${userinfo.auth.userArray.access_token}`
          }
        })
        .then(async (res) => {
const data=res.data.data.data.filter((item)=>item?.is_active==1)

          const option = data.map((item) => ({
            label: item?.name,
            value: item?.id
          }));
          setItems(option)
        })
        .catch((error) => {


        });






    }
    getAllApis()

  }, [])

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);


    try {
      const response = await axios.post('https://nanosoft.space/taarteb/public/api/salaries', {
        user_id: employee_id.value,
        // grade_id,
        salary: price,
        year: grade_id.value,
        month: type_id.value,
        bonus: bonous ? bonous : 0,
        bonus_reason: bonus_reason,
        deduction: deduction ? deduction : 0,
        deduction_reason: deduction_reason

      }, {
        headers: {
          Authorization: `Bearer ${userinfo.auth.userArray.access_token}`
        }
      });


      toast.success(response.data.message, { position: "bottom-right", autoClose: 3000 });
      navigate('/dashboard/salaries')

    } catch (error) {
      toast.error(Object.values(error.response.data.errors)[0][0], { position: "bottom-right", autoClose: 3000 });


    } finally {
      setLoading(false);
    }
  };


  let years = []; // your array for years

  // get current year
  const currentYear = new Date().getFullYear();

  // only add if not found
  if (!years.includes(currentYear)) {
    years.push(currentYear);
  }

  const options = years.map((year) => ({
    label: year,
    value: year,
  }));


  const gradoptions = [
    { label: "يناير", value: '1' },
    { label: "فبراير", value: '2' },
    { label: "مارس", value: '3' },
    { label: "أبريل", value: '4' },
    { label: "مايو", value: '5' },
    { label: "يونية", value: '6' },
    { label: "يوليه", value: '7' },
    { label: "أغسطسطس", value: '8' },
    { label: "سمبتمبر", value: '9' },
    { label: "أكتوبر", value: '10' },
    { label: "نوفمبر", value: '11' },
    { label: "ديسمبر", value: '12' },
  ];
  const employee = [
    { label: "أحمد", value: 'first' },
    { label: "محمد", value: 'second' },
  ];

  return (
    <div className='add_Maintenance_form_container'>
      <ToastContainer />

      <form className='form_container w-75'>
        <Container fluid>
          <Row>
            <Col md={6}>
              <div>
                <label>{currentLocal.home.Selectyear}</label>
                <br />
                <div className='mb-3'>
                  <Select
                    value={grade_id}
                    onChange={(selectedOption) => setGrade_id(selectedOption)}
                    options={options}
                    search
                    placeholder={currentLocal.home.Selectyear} // Change this text

                  />
                </div>
              </div>
            </Col>
            <Col md={6}>
              <div>
                <label>{currentLocal.home.SelectMonth}</label>
                <Select
                  value={type_id}
                  onChange={(selectedOption) => setType_id(selectedOption)}
                  options={gradoptions}
                  placeholder={currentLocal.home.SelectMonth} // Change this text

                />
              </div>
            </Col>
            <Col md={6}>
              <div>
                <label>{currentLocal.home.employee}</label>
                <Select
                  value={employee_id}
                  onChange={(selectedOption) => setEmployee_id(selectedOption)}
                  options={items}
                  placeholder={currentLocal.home.employee} // Change this text

                />
              </div>


            </Col>
            <Col md={6}>
              <div>
                <label>{currentLocal.home.Salary}</label>
                <CustomInput
                  placeholder={currentLocal.home.price}
                  value={price}
                  onChange={(e) => setPrice(e.target.value)}
                />
              </div>


            </Col>
            {localStorage.getItem("type") === "salaries" &&
              <>
                <Col md={6}>
                  <div>
                    <label>{currentLocal.home.Bonuses}</label>
                    <CustomInput
                      placeholder={currentLocal.home.Bonuses}
                      value={bonous}
                      onChange={(e) => setBonous(e.target.value)}
                    />
                  </div>


                </Col>
                <Col md={6}>
                  <div>

                    <label>{currentLocal.home.Reasonforrewards}</label>
                    <br />
                    <textarea
                      placeholder={currentLocal.home.Reasonforrewards}
                      value={bonus_reason}
                      onChange={(e) => setBonus_reason(e.target.value)}
                      className='w-100 form-control'

                    />
                  </div>


                </Col>
                <Col md={6}>
                  <div>
                    <label>{currentLocal.home.Discounts}</label>
                    <CustomInput
                      placeholder={currentLocal.home.Discounts}
                      value={deduction}
                      onChange={(e) => setDeduction(e.target.value)}
                    />
                  </div>


                </Col>
                <Col md={6}>
                  <div>

                    <label>{currentLocal.home.Reasonfordiscount}</label>
                    <br />
                    <textarea
                      placeholder={currentLocal.home.Reasonfordiscount}
                      value={deduction_reason}
                      onChange={(e) => setDeduction_reason(e.target.value)}
                      className='w-100 form-control'

                    />
                  </div>


                </Col>


              </>

            }




            <Col md={12}>
              <div className='d-flex justify-content-center mt-4 '>
                <div className='w-50 d-flex justify-content-center'>
                  <CustomBtn text={loading ? currentLocal.home.Loading : currentLocal.home.add} disabled={loading} clickingFunction={handleSubmit} />

                </div>
              </div>
            </Col>
          </Row>
        </Container>
      </form>
    </div>
  )
}


export default AddSalariesForm
